// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_AtivarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * PlanoMetas Ativar Response Contract
 *
 * Response for POST /plano_metas/ativar/:id - Activate a goal plan
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 *
 * @package Contracts
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type PlanoMetas_AtivarResponseDados = null;

export type PlanoMetas_AtivarResponse = ApiResponse<PlanoMetas_AtivarResponseDados>;

registerResponseContract('PlanoMetas_AtivarResponse', {})
